import type { QrCodeSettings } from '@branchjs/neo-components';

export const QR_CODE_DEFAULT_SETTINGS: QrCodeSettings = {
  code_color: '#000000',
  background_color: '#FFFFFF',
  finder_pattern: 1,
  code_pattern: 1,
  finder_pattern_color: '#000000',
  center_logo_url: '',
  background_image_url: '',
};
